(() => {
  const initialise = scope => {
    scope.querySelectorAll('[data-dh-journal-article]').forEach(root => {
      if (root.dataset.journalReady) return;
      root.dataset.journalReady = 'true';
      const body = root.querySelector('[data-dh-journal-body]');
      const contents = root.querySelector('[data-dh-journal-contents]');
      const nav = root.querySelector('[data-dh-journal-toc]');
      if (!body || !contents || !nav) return;
      const headings = [...body.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `journal-section-${index + 1}`;
        heading.tabIndex = -1;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        nav.append(link);
      });
      contents.hidden = headings.length === 0;
      nav.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const heading = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!heading) return;
        event.preventDefault();
        history.replaceState(null, '', link.hash);
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
